import React from 'react';
import { classes } from './NavigationToast.st.css';
import { NavigationToastProps } from './NavigationToast.types';
import { Toast } from '../Toast';
import { TextButton } from '../TextButton';
import { ArrowBentUpLeft } from '@wix/wix-ui-icons-common';
import { useToastTimeout } from '../StatusToast/hooks/useToastTimeout';
import { dataHooks } from './NavigationToast.constants';
import { useIcons } from '../WixDesignSystemIconThemeProvider';

const NavigationToast = ({
  children,
  dataHook,
  prefixIcon,
  onAction,
  duration = 0,
  dismissible = true,
  ...rest
}: NavigationToastProps) => {
  const icons = useIcons('NavigationToast', {
    ArrowBentUpLeft,
  });

  const defaultPrefixIcon = <icons.ArrowBentUpLeft />;

  useToastTimeout(duration || undefined, rest.onDismiss);

  return (
    <Toast
      dataHook={dataHook}
      className={classes.toast}
      dismissible={dismissible}
      {...rest}
    >
      <div
        onClick={onAction}
        className={classes.root}
        data-hook={dataHooks.actionContainer}
      >
        <TextButton
          className={classes.actionButton}
          skin="light"
          size="medium"
          weight="normal"
          underline="onHover"
          prefixIcon={
            prefixIcon === undefined
              ? defaultPrefixIcon
              : prefixIcon || undefined
          }
          dataHook={dataHooks.text}
        >
          {children}
        </TextButton>
      </div>
    </Toast>
  );
};

NavigationToast.displayName = 'NavigationToast';

export { NavigationToast };
